import React from 'react'

import "./heroSection.css"

import headerBanner from '../../../assets/headBanner.png';

const HeroSection = () => {

  const rsvp = () => {

    window.open('https://mcdtdcubx05.typeform.com/to/icUO5tQR','_blank')
    
  }

  return (

    <div className='heroSection'>

    <img src={headerBanner} className="headerBanner"/>

    <div className="floater-section">

      <div className="floater-heading">FINCLAVE 2022</div>
      <div className="floater-title">India’s Biggest Financial Conclave</div>
 

    <div className='floaterContainer'>
        <div className="eventdateContainer">
            <div className="eventDateText">EVENT DATE</div>
            <div className="eventDate">17th April, 2022</div>
        </div>

        <div className="eventvenueContainer">
            <div className="eventVenueText">EVENT VENUE</div>
            <div className="eventVenue">Four Seasons, Worli, Mumbai</div>
        </div>

        <button className='floater-cta' onClick={()=>rsvp()} >RSVP</button>


    </div>
    </div>

    </div>
  )
}

export default HeroSection